import type { TourStep } from '@/components/ui/Tour';
import { CAMP_CREATE_TOUR_STEP_IDS } from '../tour-constants';
import { TourStepContent } from './StepContent';

/** Single-camp drawer — details, schedule, pricing, and save. */
export const campSingleCreateTourSteps: TourStep[] = [
  {
    content: (
      <TourStepContent
        title="Create a camp"
        description="Set up one holiday or intensive camp families can book on your public page. Use Multiple camps from the menu when you need a batch with shared defaults."
      />
    ),
    selectorId: CAMP_CREATE_TOUR_STEP_IDS.DRAWER,
    position: 'left',
  },
  {
    content: (
      <TourStepContent
        title="Camp details"
        description="Name the camp, optionally link a development program, and choose sport and skill level."
      />
    ),
    selectorId: CAMP_CREATE_TOUR_STEP_IDS.DETAILS,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Camp dates"
        description="Pick the start date and weekdays the camp runs. Repeat weekly when you are creating a short series from this drawer."
      />
    ),
    selectorId: CAMP_CREATE_TOUR_STEP_IDS.SCHEDULE,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Session times & capacity"
        description="Set daily start and end times, then choose how many students can enrol."
      />
    ),
    selectorId: CAMP_CREATE_TOUR_STEP_IDS.TIMES,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Pricing"
        description="Set per-day and full-camp prices. Families can book individual days or the full package at checkout."
      />
    ),
    selectorId: CAMP_CREATE_TOUR_STEP_IDS.PRICING,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Courts, coaches & listing"
        description="Assign courts and coaches, add a description and cover image, and control whether the camp is active or featured."
      />
    ),
    selectorId: CAMP_CREATE_TOUR_STEP_IDS.RESOURCES,
    position: 'top',
  },
  {
    content: (
      <TourStepContent
        title="Save the camp"
        description="Create the camp when you are ready. You can edit details later from the camp list."
      />
    ),
    selectorId: CAMP_CREATE_TOUR_STEP_IDS.SUBMIT,
    position: 'top',
  },
];
